<template>
  <div class="add-new-tag">
    <h1>Add new tag</h1>
    <p>
      Allows you to create a new tag to be added to filters in agenda.
    </p>
    <div class="input-wrap">
      <label for="tag-input">Tag name</label>
      <input
        type="text"
        id="tag-input"
        placeholder="Type tag name here"
        v-model="tagName"
      />
      <small> The name is how it appears on your site. </small>
      <a-button type="primary" class="btn" @click="createTag(tagName)">
        Add New Tag
      </a-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      tagName: "",
    };
  },
  methods: {
    async createTag(name) {
      if (!name) return;
      try {
        let res = await api.postTag({
          tag_name: name,
        });
        this.openToast(this.$t("adminTags.createOk"));
        this.EventBus.$emit("reloadTags");
        this.tagName = "";
      } catch (error) {
        console.warn(error);
        this.customError(this.$t("adminTags.fail"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-tag {
  padding: 16px 24px;
  height: 337px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
  margin: 0 0 24px 0;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #001529;
    border-bottom: 1px solid #dfe1e6;
    padding: 0 0 16px 0;
  }
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #001529;
    max-width: 850px;
    margin: 16px 0 25px 0;
  }
  .input-wrap {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    label {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #001529;
      margin: 8px 0;
    }
    input {
      background: #ffffff;
      border: 1px solid #dfe1e6;
      box-sizing: border-box;
      border-radius: 2px;
      max-width: 400px;
    }
    small {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #001529;
      margin: 8px 0 30px 0;
    }
  }
}
</style>